import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_MOCK_USER: (mockUserId) => ({ mockUserId }),
    API: {
      GET_MOCK_USER: apiResourceActionCreator('mockUser')
    }
  }
})

export const apiAction = (authToken, mockUserId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getMockUser/${mockUserId}`, authToken, action.admin.api.getMockUser)

function* getMockUser(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.mockUserId));
}

const configuration = {
  name: 'getMockUser',
  action: action,
  sagas: getMockUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingUser: true
    }),
    success: (state, action) => {
      return ({
        ...state,
        isFetchingUser: false,
        mockUser: action.payload.mockUser
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingUser: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getMockUser.js